function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
module.exports = function (purchaseService, _ref) {
  var isProduct = _ref.isProduct;
  var priceTaxFeeAdjuster = /*#__PURE__*/function () {
    function priceTaxFeeAdjuster(supplementalData) {
      _classCallCheck(this, priceTaxFeeAdjuster);
      this.name = "discountontotal";
      this.id = priceTaxFeeAdjuster.nextId;
      // same as priceoverride
      this.priority = priceTaxFeeAdjuster.taxPriority - 50;
      this.supplementalData = supplementalData;
      priceTaxFeeAdjuster.nextId++;
      var priceoverridePtf = purchaseService.priceTaxFeeAdjusters.find(function (a) {
        return a.name === "manualdiscount";
      });
      var totaldisc = 0;
      var basketPercentage = Math.round(supplementalData.discountAmount / supplementalData.subtotal * 100);
      purchaseService.purchases.filter(function (p) {
        return isProduct(p) && !p.isFree && !p.refund;
      }).forEach(function (p, i, arr) {
        var discountPortion = 0;
        priceoverridePtf.removeManualdiscount(p);
        if (supplementalData.discountAmount > 0) {
          if (i === arr.length - 1) {
            discountPortion = Math.round(supplementalData.discountAmount - totaldisc);
          } else {
            // getPrice() already accounts for refund, but manual-discount is refund-neutral and ptf calculation adds refund consideration at basket-recalc time so we must neutralize refund coef here
            var modifierDelta = p.priceTaxFeeAdjustments ? p.priceTaxFeeAdjustments.reduce(function (total, a) {
              return a.name === "itemModifierPTF" ? total + a.price : total;
            }, 0) : 0;
            discountPortion = Math.round(basketPercentage / 100 * (p.getPrice() + modifierDelta)) * (p.refund ? -1 : 1);
            totaldisc += discountPortion;
          }
          priceoverridePtf.addManualdiscount(p, "cents", discountPortion);
        } else if (supplementalData.discountPercentage) {
          priceoverridePtf.addManualdiscount(p, "percent", supplementalData.discountPercentage / 100);
        }
      });
    }
    return _createClass(priceTaxFeeAdjuster, [{
      key: "calculate",
      value: function calculate(productlist) {
        // this is a "parasitic" PTF - it lives off priceoverridePtf so all the work is done there...
      }
    }, {
      key: "calculateInt",
      value: function calculateInt(productlist) {
        // int values already populated
      }
    }]);
  }();
  priceTaxFeeAdjuster.nextId = 0;
  priceTaxFeeAdjuster.taxPriority = 0; // so positive priorities are post-tax adjusters and negative values are pre-tax

  return {
    priceTaxFeeAdjuster: priceTaxFeeAdjuster
  };
}(require('../../module/purchase/service.js'), require('../../utils.js'));